import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import Creator from "@/pcm/store/models/Creator";
import Currency from "@/pcm/store/models/Currency";
import {Statuses} from "@/pcm/types/interfaces/Statuses";
import User from "@/pcm/store/models/User";
import Network from "@/pcm/store/models/Network";
import Client from "@/pcm/store/models/Client";
import Channel from "@/pcm/store/models/Channel";

export default class ClientContract extends Model {
    static entity = 'client_contracts';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'id',
    };

    static fields() {
        return {
            id: this.uid(),
            client_id: this.attr(null),
            currency_id: this.attr(null),
            user_id: this.attr(null),
            step: this.number(0),
            status: this.string('concept'),
            revenue_share: this.number(null).nullable(),
            channels: this.attr([]).nullable(),
            signed_at: this.string(null).nullable(),
            is_checked: this.boolean(false),
            is_paid: this.boolean(false),
            signed_contract: this.string('').nullable(),

            signed_client_contract_url: this.string(null).nullable(),
            additional_documents_client_contract_urls: this.attr([]).nullable(),
            creators: this.attr([]).nullable(),

            created_at: this.string(''),
            updated_at: this.string(''),

            client: this.belongsTo(Client, 'client_id'),
            user: this.belongsTo(User, 'user_id'),
            currency: this.belongsTo(Currency, 'currency_id'),
        }
    }

    declare id: number;
    declare client_id: number;
    declare user_id: number;
    declare currency_id: number;
    declare step: number;
    declare status: Statuses;
    declare revenue_share: number | null;
    declare channels: Array<Channel>;
    declare signed_at: string | null;
    declare signed_client_contract_url: string | null;
    declare additional_documents_client_contract_urls: Array<any>;
    declare creators: Array<any>;
    declare is_checked: boolean;
    declare is_paid: boolean;

    declare client: Client;
    declare user: User;
    declare currency: Currency;
}
